export * from './providerConfig';
export * from './thumbnail';
export * from './template';
export * from './providerSource';
export const AB_TESTING_SUPPORTED_PAGE_TYPES = [
  'template-page',
  'template-index',
  'template-article',
  'template-product',
  'template-collection',
];
